var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.list && _setup.chartHeight)?_c('apexchart',{ref:"apex-chart",attrs:{"height":_setup.chartHeight,"options":_setup.apex.options(_vm.type, _vm.list, _vm.locale, _setup.getTheme()),"series":_setup.apex.series(_vm.list, _vm.label)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }